import { LinearProgress } from "@mui/material"
import { Box } from "@mui/system"

export type Score = {
    id: string;
    name: string;
    score: number;
    color: string | undefined;
}

const ScoresComponent = ({ scores, limit }: {scores: Score[], limit?: number}) => {
    let limitedScores = scores 
    if (limit) {
        limitedScores = scores?.slice(0, limit)
    }

    return <>
        {limitedScores.map(({ id, name, score, color }, i) => (
            <Box
                display="grid"
                gridTemplateColumns={{ xs: '1fr', md: '1fr 2fr' }}
                gap={2}
                sx={{ marginBottom: 6 }}
                key={i}
            >
                <Box sx={{ width: '100%'}}>
                    {/* <Type size={20} color="#5f5faf" /> */}
                    <span style={{ fontSize: '1.15em', fontWeight: "bold", color: "535353" }}>{name}</span>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <LinearProgress
                        variant="determinate"
                        value={score}
                        sx={{
                            height: 5,
                            borderRadius: 5,
                            backgroundColor: '#f0f1f5',
                            marginTop: 2,
                            '& .MuiLinearProgress-bar': { backgroundColor: color },
                        }}
                    />
                    {score}%
                </Box>
            </Box>
        ))}
    </>
}

export default ScoresComponent